import React from "react";
import { Type } from "../../shared/utils/enums";

export type TypeBadgeType = Type | "cpt" | "icd" | "ndc" | "service";

interface TypeBadgeProps {
  type: TypeBadgeType;
}

const TypeBadge: React.FC<TypeBadgeProps> = ({ type }) => {
  const getTypeStyles = () => {
    switch (type) {
      case Type.DOCUMENT:
      case "cpt":
        return "text-blue-700 bg-blue-100";
      case Type.FEATURE:
      case "icd":
        return "text-green-700 bg-green-100";
      case Type.BUG:
      case "ndc":
        return "text-purple-700 bg-purple-100";
      case "service":
        return "text-yellow-700 bg-yellow-100";
      default:
        return "text-gray-700 bg-gray-100";
    }
  };

  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium ${getTypeStyles()}`}
    >
      {typeof type === "string" ? type.toUpperCase() : type}
    </span>
  );
};

export default TypeBadge;
